import { graphql, HttpResponse } from 'msw'
import { type AuthReentryData, type AuthReentrySubmitOutput } from '../../models/authn/re-entry'

// Mock data for auth re-entry
export const authReentryDataMock: AuthReentryData = {
  email: 'test@example.com',
  phone: {
    phoneNumber: '1234567890',
    countryPhoneCode: 1,
  },
  nextStep: 'VERIFY_EMAIL',
  error: null,
  path: '/return/verify-email',
}

export const authReentrySubmitOutputMock: AuthReentrySubmitOutput = {
  nextStep: 'VERIFY_EMAIL',
  error: null,
  email: 'test@example.com',
  phone: {
    phoneNumber: '1234567890',
    countryPhoneCode: 1,
  },
  path: '/return/enter-phone',
}

// MSW handlers for auth re-entry endpoints
export const getAuthReentryDataHandler = graphql.mutation('getAuthReentryData', () => {
  return HttpResponse.json({
    data: {
      enterApplication: authReentryDataMock,
    },
  })
})

export const submitAuthReentryDataHandler = graphql.mutation('submitAuthReentryData', ({ variables }) => {
  // Handle different submission types based on input
  const input = variables?.input || {}

  if (input.emailVerificationCode) {
    // Email verification
    return HttpResponse.json({
      data: {
        enterApplication: {
          ...authReentrySubmitOutputMock,
          nextStep: 'SUBMIT_PHONE',
        },
      },
    })
  }

  if (input.phoneVerificationCode) {
    // Phone verification
    return HttpResponse.json({
      data: {
        enterApplication: {
          ...authReentrySubmitOutputMock,
          nextStep: 'SESSION_RESTORED',
        },
      },
    })
  }

  if (input.phone) {
    // Phone submission
    return HttpResponse.json({
      data: {
        enterApplication: {
          ...authReentrySubmitOutputMock,
          nextStep: 'VERIFY_PHONE',
        },
      },
    })
  }

  if (input.triggerEmailOtp || input.triggerPhoneOtp) {
    // Resend code
    return HttpResponse.json({
      data: {
        enterApplication: authReentrySubmitOutputMock,
      },
    })
  }

  // Default response
  return HttpResponse.json({
    data: {
      enterApplication: authReentrySubmitOutputMock,
    },
  })
})

export const mockAuthReentry = [getAuthReentryDataHandler, submitAuthReentryDataHandler]
